module.exports = __webpack_public_path__ + "static/media/upload-success@2x.d08292e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/upload-success@2x.png
// module id = 919
// module chunks = 0